import {
  borderRadius,
  ButtonGroup,
  SkeletonLoader,
} from '@toggle/design-system';
import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  width: 100%;
  padding: 20px;
`;

export const StyledButtonGroup = styled(ButtonGroup)`
  border-radius: 12px;
  border: 1px solid var(--border-soft);
  background: var(--background-soft);
  height: 40px;

  ${ButtonGroup.Styles.ButtonGroupItem} {
    ${borderRadius.r2};
    text-transform: none;
  }

  margin-bottom: 24px;
`;

export const LoadingSkeletonLarge = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '40px',
        borderRadius: '8px',
      },
    },
  ],
})``;

export const LoadingSkeletonMedium = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '65%',
        height: '32px',
        borderRadius: '8px',
      },
    },
  ],
})``;

export const LoadingSkeletonSmall = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '55%',
        height: '32px',
        borderRadius: '8px',
      },
    },
  ],
})``;

export const LoaderWrapper = styled.div`
  padding-top: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
